import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import DatePickerField from './DatePickerField';
import { getSelectStyles } from './SearchableSelect';
import { poSalesFilterFields } from '../utils/poSalesListing';

export default function PoSalesFilters({ records, filters, onChange }) {
  const [expanded, setExpanded] = useState(false);
  const options = useMemo(() => Object.fromEntries(poSalesFilterFields.filter(field => field.type === 'select').map(field => [
    field.key, (field.choices || [...new Set(records.map(field.value).filter(Boolean))].sort((a, b) => a.localeCompare(b)))
      .map(value => ({ value, label: value })),
  ])), [records]);
  const update = (key, value) => onChange({ ...filters, [key]: value });
  return <div className="mb-4">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h5 className="mb-0 font-20 text-quote-dark">Filters</h5>
      <button type="button" className="btn-quote-blue btn btn-primary py-2 px-2"
        aria-label={expanded ? 'Hide filters' : 'Show filters'} aria-expanded={expanded}
        onClick={() => setExpanded(value => !value)}>
        <FontAwesomeIcon icon={expanded ? faMinus : faPlus} />
      </button>
    </div>
    {expanded && <>
      <div className="row g-3 border-top mt-3">
        {poSalesFilterFields.map(({ key, label, type }) => <div className="col-md-3" key={key}>
          <label htmlFor={'po-filter-' + key}>{label}</label>
          {type === 'select' ? <Select inputId={'po-filter-' + key} isMulti options={options[key]}
            value={(filters[key] || []).map(value => ({ value, label: value }))}
            onChange={selected => update(key, (selected || []).map(option => option.value))}
            menuPortalTarget={document.body} styles={getSelectStyles()} />
            : type === 'date' ? <DatePickerField id={'po-filter-' + key} name={key}
              value={filters[key] || ''} onChange={value => update(key, value)} />
              : <input id={'po-filter-' + key} className="form-control" value={filters[key] || ''}
                onChange={event => update(key, event.target.value)} />}
        </div>)}
      </div>
      <button type="button" className="btn btn-outline-secondary btn-sm mt-3" onClick={() => onChange({})}>Clear filters</button>
    </>}
  </div>;
}
